module.exports = __webpack_public_path__ + "static/media/answer-buttions.58ee4ccc.png";